// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ArrowDownFilled from '../_raw/ui/icon_arrow_down_filled.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ArrowDownFilled);
